import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  LetterOfCreditSearchCriteria,
  RestLetterOfCreditListRequest,
  RestPageListBean,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox } from "../gui_components/UIComponents.js";
import { isEmptyString } from "../gui_components/Util.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
export class LetterOfCreditLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, fabricCode, colorCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.fabricCode = fabricCode;
    this.colorCode = colorCode;
    let resetCriteria = new LetterOfCreditSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new LetterOfCreditSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let locLookupCriteria = new LetterOfCreditSearchCriteria();
    locLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = LOCLookupCriteraHandler(
      companyCode,
      locLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(lookupDataCallback, locLookupCriteria, lookupCriteriaView);
    ModuleUtils.getLetterOfCreditStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(
      this.attribute_name,
      "letterOfCreditNumber",
      0,
      true
    ); //1
    this.addColumnDefinition("Vendor", "vendorCode", 0, false); //2
    this.addColumnDefinition("Name", "vendorName", 0, false); //3
    this.addColumnDefinition("Status", "status", 0, false); //3
    this.addColumnDefinition("CreatedDate", "createdDate", 0, false); //3
  }
  loadLOCList = (lookup_dialog, pageNumber, searchCriteria) => {
    let locCriteria = new LetterOfCreditSearchCriteria(); //To be fetched from CriteriaHandler
    locCriteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      locCriteria.letterOfCreditNumber = searchCriteria.letterOfCreditNumber;
      locCriteria.letterOfCreditNumberStartsWith =
        searchCriteria.letterOfCreditNumberStartsWith;
      locCriteria.letterOfCreditNumberContains =
        searchCriteria.letterOfCreditNumberContains;
    }
    let pageList = new RestPageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = 1;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestLetterOfCreditListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = locCriteria;
    AccountPayableService.getLetterOfCreditPageList(
      requestInput,
      (response) => this.loadLOCPageResponse(response, lookup_dialog),
      this.loadLOCPageError
    );
  };
  loadLOCPageResponse = (response, lookup_dialog) => {
    let locList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.pageList != null &&
      response.data.pageList.letterOfCredits !== null
    ) {
      locList = response.data.pageList.letterOfCredits;
      totalCount = response.data.pageList.totalCount;
      currentPageNumber = response.data.pageList.currentPage;
      pageSize = response.data.pageList.pageSize;
      locList.map((lc) => {
        lc.status = ModuleUtils.getLetterOfCreditStatusCaption(lc.status);
      });
    }
    let lookup_result_details = new LookupResultDetails();
    this.lookupdata = locList;
    lookup_result_details.pageData = this.lookupdata;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadLOCPageError = (error) => {};
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.letterOfCreditNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.letterOfCreditNumberContains = filterText;
        this.searchCriteria = new LetterOfCreditSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadLOCList(lookup_dialog, pageNumber, search);
    }
  }
}
const LOCLookupCriteraHandler = (companyCode) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new LetterOfCreditSearchCriteria(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new LetterOfCreditSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>LOC#</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="letterOfCreditNumber"
                  name="letterOfCreditNumber"
                  onChange={this.onChange}
                  value={searchCriteria.letterOfCreditNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>LOC StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="letterOfCreditNumberStartsWith"
                  name="letterOfCreditNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.letterOfCreditNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>LOC Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="letterOfCreditNumberContains"
                  name="letterOfCreditNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.letterOfCreditNumberContains}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
